import { Division } from '../shared/enums';
import { DivisionConfig } from './division.config.interface';

export const divisionConfig: DivisionConfig = {
  skillsPhoneNumber: {
    [Division.tns]: '01275 547 242',
    [Division.sng]: '01275 547 242',
    [Division.ni]: '01275 547 242',
    [Division.roi]: '0044 1275 547 242',
    [Division.notDefined]: '',
  },
  shiftSupportEmail: {
    [Division.tns]: 'shifts@tnsltd.com',
    [Division.sng]: 'callcentre@nursingguild.com',
    [Division.ni]: 'belfast@nursingguild.com',
    [Division.roi]: 'dublin@nursingguild.com',
    [Division.notDefined]: '',
  },
  shiftSupportPhoneNumber: {
    [Division.tns]: '0345 120 5305',
    [Division.sng]: '0131 229 9988',
    [Division.ni]: '0333 323 0337',
    [Division.roi]: '01 902 3080',
    [Division.notDefined]: '',
  },
  pullingOutNumber: {
    [Division.tns]: '0345 120 5305',
    [Division.sng]: '0131 229 9988',
    [Division.ni]: '0333 323 0337',
    [Division.roi]: '01 902 3080',
    [Division.notDefined]: '',
  },
  timesheetsEmail: {
    [Division.tns]: 'timesheets.tns@ukics.com',
    [Division.sng]: 'timesheets.sng@ukics.com',
    [Division.ni]: 'timesheets.sng@ukics.com',
    [Division.roi]: 'timesheets.sngroi@ukics.com',
    [Division.notDefined]: '',
  },
  phoneRtc: {
    [Division.tns]: '0345 120 5251',
    [Division.sng]: '0345 120 5253',
    [Division.ni]: '0345 120 5253',
    [Division.roi]: '01 902 3083',
    [Division.notDefined]: '',
  },
  emailRtc: {
    [Division.tns]: 'rtc@tnsltd.com',
    [Division.sng]: 'training@nursingguild.com',
    [Division.ni]: 'training@nursingguild.com',
    [Division.roi]: 'training@nursingguild.com',
    [Division.notDefined]: '',
  },
  phoneDd: {
    [Division.tns]: '0345 120 5305',
    [Division.sng]: '0345 002 0935',
    [Division.ni]: '0333 323 0337',
    [Division.roi]: '01 902 3080',
    [Division.notDefined]: '',
  },
  payRatesUrl: {
    [Division.tns]: 'https://thornbury-nursing.com/benefits/pay-rates/',
    [Division.sng]: 'https://nursingguild.com/benefits/pay-rates/',
    [Division.ni]: 'https://nursingguild.com/benefits/pay-rates/',
    [Division.roi]: 'https://nursingguild.com/benefits/pay-rates/',
    [Division.notDefined]: '',
  },
  standardPayRatesUrl: {
    [Division.tns]:
      'https://tnssng.fra1.digitaloceanspaces.com/tnsltd/wp/wp-content/uploads/2023/07/TNS_Eng_Wales_Pay_Rates_from_Jul_2023.pdf',
    [Division.sng]:
      'https://tnssng.fra1.digitaloceanspaces.com/sngltd/wp/wp-content/uploads/2023/07/SNG_Scotland_NI_Pay_Rates_from_Jul_2023.pdf',
    [Division.ni]:
      'https://tnssng.fra1.digitaloceanspaces.com/sngltd/wp/wp-content/uploads/2023/07/SNG_Scotland_NI_Pay_Rates_from_Jul_2023.pdf',
    [Division.roi]:
      'https://tnssng.fra1.digitaloceanspaces.com/sngltd/wp/wp-content/uploads/2023/07/SNG_ROI_Standard_Pay_Rates_from_Jul_2023.pdf',
    [Division.notDefined]: '',
  },
  specialistPayRatesUrl: {
    [Division.tns]:
      'https://tnssng.fra1.digitaloceanspaces.com/tnsltd/wp/wp-content/uploads/2023/07/TNS_ANP_ANNP_APNP_ECP_ENP_Pay_Rates_2023.pdf',
    [Division.sng]:
      'https://tnssng.fra1.digitaloceanspaces.com/sngltd/wp/wp-content/uploads/2023/07/SNG_Scot_NI_ANP_ANNP_APNP_ECP_ENP_Pay_Rates_2023.pdf',
    [Division.ni]:
      'https://tnssng.fra1.digitaloceanspaces.com/sngltd/wp/wp-content/uploads/2023/07/SNG_Scot_NI_ANP_ANNP_APNP_ECP_ENP_Pay_Rates_2023.pdf',
    [Division.roi]: '',
    [Division.notDefined]: '',
  },
  privatePayRatesUrl: {
    [Division.tns]: '',
    [Division.sng]: '',
    [Division.ni]: '',
    [Division.roi]:
      'https://tnssng.fra1.digitaloceanspaces.com/sngltd/wp/wp-content/uploads/2023/07/SNG_ROI_Private_Pay_Rates_from_Jul_2023.pdf',
    [Division.notDefined]: '',
  },
  complianceListAnnualUpdatePhoneNumber: {
    [Division.tns]: '0345 120 5251',
    [Division.sng]: '0345 120 5253',
    [Division.ni]: '0345 120 5253',
    [Division.roi]: '01 902 3081',
    [Division.notDefined]: '',
  },
  newIdBadgePhoneNumber: {
    [Division.tns]: '0345 120 5251',
    [Division.sng]: '0345 120 5253',
    [Division.ni]: '0345 120 5253',
    [Division.roi]: '01 902 3081',
    [Division.notDefined]: '',
  },
  cantFindTrainingNumber: {
    [Division.tns]: '0345 120 5251',
    [Division.sng]: '0345 120 5253',
    [Division.ni]: '0345 120 5253',
    [Division.roi]: '01 902 3083',
    [Division.notDefined]: '',
  },
  rearrangeCancelBookTraining: {
    [Division.tns]: '0345 120 5251',
    [Division.sng]: '0345 120 5253',
    [Division.ni]: '0345 120 5253',
    [Division.roi]: '01 902 3083',
    [Division.notDefined]: '',
  },
  welcomePackIdBadgePhoneNumber: {
    [Division.tns]: '0345 120 5252',
    [Division.sng]: '0345 002 0936',
    [Division.ni]: '0333 3230338',
    [Division.roi]: '01 902 3081',
    [Division.notDefined]: '',
  },
  complaintsPhoneNumber: {
    [Division.tns]: '01275 547 221',
    [Division.sng]: '0127 554 7221',
    [Division.ni]: '01275 547 221',
    [Division.roi]: '01 513 4608',
    [Division.notDefined]: '',
  },
  welcomePackComplaintsEmail: {
    [Division.tns]: 'qualityassurance@tnsltd.com',
    [Division.sng]: 'qualityassurance@nursingguild.com',
    [Division.ni]: 'qualityassurance@nursingguild.com',
    [Division.roi]: 'qualityassurance@nursingguild.com',
    [Division.notDefined]: '',
  },
  agencyWorkerRegulations: {
    [Division.tns]: 'https://www.legislation.gov.uk/uksi/2010/93/contents/made',
    [Division.sng]: 'https://www.legislation.gov.uk/uksi/2010/93/contents/made',
    [Division.ni]: 'https://www.legislation.gov.uk/uksi/2010/93/contents/made',
    [Division.roi]:
      'https://www.workplacerelations.ie/en/what_you_should_know/employment_types/agency-workers/',
    [Division.notDefined]: '',
  },
};
